import {
  Button,
  Dialog,
  DialogActions,
  DialogContentText
} from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { DialogContent, DialogTitle } from "../../../components/dialog";
import { useContactCrm } from "../../../hooks";
import { SmsTemplate } from "../../../types";
import { SmsTemplatesConfig } from "../SmsTemplatesRoutes";

type ConfirmDeleteDialogProps = {
  open: boolean;
  templateToDelete: Pick<SmsTemplate, "id" | "name">;
  onClose: () => void;
};

export default function ConfirmDeleteDialog({
  open,
  templateToDelete: { id, name },
  onClose,
}: ConfirmDeleteDialogProps) {
  const crm = useContactCrm();
  const history = useHistory();

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle onClose={onClose}>
        Are you sure you want to delete the following SMS Template?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{name}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} type="button">
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={async () => {
            try {
              const res = await crm.deleteSmsTemplate(id);
              if (!res) {
                throw new Error("Failed to delete SMS Template");
              }
              window.alert("SMS Template deleted successfully");
              history.push(SmsTemplatesConfig.path);
              onClose();
            } catch (err) {
              window.alert("Failed to delete SMS Template");
              console.error(err);
            }
          }}
          type="button"
          variant="contained"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
